import { fromJS, List, Record } from 'immutable';
import {
  generateKeys,
  generateSchema,
  setInModel,
} from '../../../utils/helpers/model.helper';
import { ITyped } from '../../shared/interfaces/typed.interface';
import { DashboardComponentTypesEnum } from '../reports.enum';
import { DashboardListContent } from './dashboard-list-content.model';

export const DASHBOARD_LIST_SCHEMA = Object.freeze({
  TYPE: '',
  GROUP: 0,
  CONTENT: List<DashboardListContent>([]),
});
const RECORD = generateSchema(DASHBOARD_LIST_SCHEMA);
const KEYS: any = generateKeys(DASHBOARD_LIST_SCHEMA);

export class DashboardList extends Record(RECORD) implements ITyped {
  static KEYS: any = KEYS;

  constructor(props?: any) {
    props = props && props.toMap ? props.toMap() : fromJS(props || {});

    super(props);

    const selfModel = setInModel(this, [
      {
        key: KEYS.CONTENT,
        value: props.get(KEYS.CONTENT)
          ? this.content.map((params) => new DashboardListContent(params))
          : List<DashboardListContent>([]),
      },
    ]);

    return selfModel as DashboardList;
  }

  get type(): string {
    return DashboardComponentTypesEnum.list;
  }

  get group(): number {
    return this.get(KEYS.GROUP);
  }

  get content(): List<DashboardListContent> {
    return this.get(KEYS.CONTENT);
  }
}
